module.exports = __webpack_public_path__ + "assets/Lato-Bold.0e56b17d142eb366c8007031d14e34da48c70b4a9d9a0ca492e696a7bae45e1e.woff";